import { useEffect, useState } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import userPool from '../../utils/userPool';

export const useAuth = (navigation: (arg0: string) => void) => {
  const [cognitoUser, setCognitoUser] = useState<null | CognitoUser>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    // Check if the user is currently authenticated
    checkAuthentication();
  }, []);

  function checkAuthentication() {
    // Get the current user from the user pool
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser) {
      // The user is authenticated, set the cognitoUser and isAuthenticated state values
      setCognitoUser(cognitoUser);
      setIsAuthenticated(true);
    } else {
      // The user is not authenticated, redirect to the login page
      navigation('/login');
    }
  }

  // Return the cognitoUser and isAuthenticated state values
  return { cognitoUser, isAuthenticated };
};
